module.exports = __webpack_public_path__ + "assets/img/avatar-2.a096c638.jpg";